import { doc, getDoc } from "firebase/firestore";
import { db } from "./firestore";

export interface UserAccount {
  organisationId: string;
  roles: string[];
}

export const fetchUserAccount = async (
  uid: string,
): Promise<UserAccount | null> => {
  const snapshot = await getDoc(doc(db, "users", uid));
  const data = snapshot.data();
  if (!data?.organisation_id) return null;
  return { organisationId: data.organisation_id, roles: data.roles ?? [] };
};
